import {Button} from '@primer/react'
import styles from './WhosTurnBanner.module.css'

/** Action-needed banner in the sidebar */
export function WhosTurnBanner() {
  return (
    <div className={styles.banner}>
      <p className={styles.text}>
        <span className={styles.label}>Your turn</span> karpathy requested your review.
      </p>
      <Button className={styles.compareButton}>Review changes</Button>
    </div>
  )
}
